import React, { useContext, useEffect } from 'react';
import { ButtonTheme } from '@philips-internal/oswald-ui-constants';
import { GlobalActionsStackContext } from '../../../context/global-actions-stack-context.js';
import { Button } from '../../button/button.js';
import { FormContext } from '../../form/context/form-context.js';
import { FileUploaderContentMode } from '../file-uploader-content-types.js';
function ClearButton(props) {
    return (React.createElement(Button, { className: "c-file-uploader-content__clear", key: "tws-file-uploader-clear", onClick: props.onClearClick, theme: ButtonTheme.SECONDARY, value: props.clearExpression }));
}
function ConfirmButton(props) {
    return (React.createElement(Button, { className: "c-file-uploader-content__confirm", key: "tws-file-uploader-confirm", onClick: props.onConfirmClick, theme: ButtonTheme.PRIMARY, value: props.confirmExpression }));
}
function FileUploaderActions(props) {
    const globalActionsStackContext = useContext(GlobalActionsStackContext);
    const formContext = useContext(FormContext);
    useEffect(() => {
        if (formContext || !globalActionsStackContext || props.mode === FileUploaderContentMode.MODAL_WRAPPER) {
            return;
        }
        const actions = [
            React.createElement(ClearButton, { clearExpression: props.clearExpression, key: "file-uploader-clear", onClearClick: props.onClearClick }),
            React.createElement(ConfirmButton, { confirmExpression: props.confirmExpression, key: "file-uploader-confirm", onConfirmClick: props.onConfirmClick }),
        ];
        const popActions = globalActionsStackContext.pushActions({ actions });
        return () => {
            popActions();
        };
    }, [props.mode]);
    return null;
}
export { FileUploaderActions, };
//# sourceMappingURL=file-uploader-actions.js.map